define('webshopFiltersProductsView',[
  'module',
  'marionette',
  'underscore',
  'events',
  'buttonView',
  'modalsAlertView',
  'modalsConfirmationView',
  'entities/webshop/filters',
  'template!webshopFiltersProductsView'
], function (
  Module,
  Marionette,
  _,
  Events,
  ButtonView,
  AlertView,
  ConfirmationView,
  FiltersApi,
  Tpl
) {
  'use strict';

  var PAGE_SIZE = 50;

  // Window: the products linked to one filter value. options: filter, value, onChanged().
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-filters-products-view',

    regions: {
      addRegion: '.add-region'
    },

    ui: {
      search: 'input.search',
      list: '.list',
      pager: '.pager'
    },

    events: {
      'input @ui.search': 'onSearch',
      'click .remove': 'onRemove',
      'click .prev': 'onPrev',
      'click .next': 'onNext'
    },

    initialize: function () {
      Events.push(this);
      this.first = 0;
      this.count = 0;
      this.products = [];
      this.code = '';
      this.changed = false;
    },

    onDestroy: function () {
      Events.pop(this);
      if (this.changed && this.options.onChanged)
        this.options.onChanged();
    },

    serializeData: function () {
      return {
        filterName: FiltersApi.name(this.options.filter.names),
        valueName: FiltersApi.name(this.options.value.names),
        pimWarning: !this.options.filter.webshop
      };
    },

    onShow: function () {
      this.addButton = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('webshop.filters.addProducts', null, 'Add products')
      });
      this.addButton.on('click', _.bind(this.onAdd, this));
      this.getRegion('addRegion').show(this.addButton);

      this.fetch();
    },

    fetch: function () {
      var request = FiltersApi.valueProducts({
        filterId: this.options.filter.id,
        valueId: this.options.value.valueId,
        first: this.first,
        pageSize: PAGE_SIZE,
        code: this.code
      });
      this.request = request;

      request.done(_.bind(function (result) {
        if (this.isDestroyed || request !== this.request)
          return;
        this.count = result.count;
        this.products = result.products;
        this.renderList();
      }, this)).fail(_.bind(function (message) {
        AlertView.prototype.open('', message);
      }, this));
    },

    renderList: function () {
      var html = _.map(this.products, function (p) {
        return '<div class="product" data-id="' + p.id + '">' +
          '<span class="code">' + _.escape(p.code) + '</span>' +
          '<span class="product-label">' + _.escape(p.label || '') + '</span>' +
          (p.status > 0 ? '' : '<span class="disabled">' + _.i18n('common.disabled', null, 'Disabled') + '</span>') +
          '<span class="remove" title="' + _.escape(_.i18n('common.remove', null, 'Remove')) + '"><i class="fa fa-times"></i></span>' +
          '</div>';
      }).join('');

      if (!html)
        html = '<div class="empty">' + _.i18n('webshop.filters.noProduct', null, 'No product') + '</div>';

      this.ui.list.html(html);

      var last = Math.min(this.first + PAGE_SIZE, this.count);
      this.ui.pager.html(
        '<span class="prev ' + (this.first > 0 ? '' : 'off') + '"><i class="fa fa-chevron-left"></i></span>' +
        '<span>' + (this.count ? this.first + 1 : 0) + '–' + last + ' / ' + this.count + '</span>' +
        '<span class="next ' + (last < this.count ? '' : 'off') + '"><i class="fa fa-chevron-right"></i></span>');
    },

    onSearch: function () {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(_.bind(function () {
        this.code = this.ui.search.val();
        this.first = 0;
        this.fetch();
      }, this), 300);
    },

    onPrev: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first = Math.max(0, this.first - PAGE_SIZE);
      this.fetch();
    },

    onNext: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first += PAGE_SIZE;
      this.fetch();
    },

    onRemove: function (e) {
      var id = parseInt($(e.currentTarget).closest('.product').data('id'), 10);

      FiltersApi.removeValueProducts(this.options.filter.id, this.options.value.valueId, [id])
        .done(_.bind(function () {
          this.changed = true;
          if (this.first > 0 && this.products.length === 1)
            this.first = Math.max(0, this.first - PAGE_SIZE);
          this.fetch();
        }, this)).fail(function (message) {
          AlertView.prototype.open('', message);
        });
    },

    onAdd: function () {
      require(['webshopProductsFinderView'], _.bind(function (FinderView) {
        FinderView.prototype.open({
          onSelected: _.bind(function (models) {
            var ids = _.map(models, function (m) { return m.getId(); });
            if (ids.length === 0)
              return;

            FiltersApi.addValueProducts(this.options.filter.id, this.options.value.valueId, ids)
              .done(_.bind(function () {
                this.changed = true;
                this.fetch();
              }, this)).fail(function (message) {
                AlertView.prototype.open('', message);
              });
          }, this)
        });
      }, this));
    },

    // Static methods
    open: function (data) {
      require([
        'windows',
        'webshopFiltersProductsView'
      ], function (Windows, View) {
        Windows.open({
          view: function () {
            return new View(data);
          },
          modal: true,
          width: 800,
          height: 600,
          minWidth: 500,
          minHeight: 400,
          title: FiltersApi.name(data.filter.names) + ' : ' + FiltersApi.name(data.value.names)
        });
      });
    }
  });
});

